import React, { useState, useEffect } from 'react'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { useDispatch } from 'react-redux'
import { useSolToUsdRate } from 'hooks/useSolToUsdRate'
import { useWalletModal } from '@solana/wallet-adapter-react-ui'
import { useWallet } from '@solana/wallet-adapter-react'
// next component

//components
import ImageWithFoster from 'components/ImageWithFoster'
import LoadingButton from 'components/Button/LoadingButton'
import SocialShareModal from 'components/Menu/SocialShareModal'
import SizeChartModal from 'components/Modal/SizeChartModal'
import { calculateAuctionTimeLeft, getApparelType, getTimeDifference } from 'utils/helpers'
import GradientButton from 'components/Button/GradientButton'

// images
import SolanaLogoIcon from 'assets/icons/solana-logo-gray-14x12.svg?component'
import DefaultAvatar from 'assets/images/dashboard-avatar.png'
import ThreeDotIcon from 'assets/icons/three-dot-icon.svg?component'

// json
import ShopApparelList from 'assets/json/browse-nft/shop-apparel-list.json'
import SizeList from 'assets/json/print/size-chat-modal.json'

// styles
import styles from './index.module.scss'
import { getDisplayUserName } from 'utils/strings'
import OutlineButton from 'components/Button/OutlineButton'
import Alert from 'components/Alert'
import MerchOrderDetail from '../MerchOrderDetail'
import MenuEditMerch from 'components/Menu/MenuEditMerch'
import MerchDetailEditModal from 'components/Modal/MerchDetailEditModal'
import NFTDescriptionSection from 'components/pages/BrowseNFT/MainSection/NFTDescriptionSection'
import MerchMenuEditModal from 'components/Modal/MerchMenuEditModal'

const MerchOrderMain = props => {
  const {
    type,
    username,
    productDetail,
    userDetail,
    onClickBuyNow,
    setQuantity,
    setMerchSize,
    setMerchColor,
    productId,
    data,
    setData,
    merchList,
    rawList,
  } = props
  const router = useRouter()
  const dispatch = useDispatch()
  const { connected, publicKey } = useWallet()
  const { setVisible } = useWalletModal()
  const { solToUsdRate } = useSolToUsdRate()
  const [openShareModal, setOpenShareModal] = useState(false)
  const [share, setShare] = useState<boolean>(false)
  const [shareCount, setShareCount] = useState(0)

  const [tableModal, setTableModal] = useState(false)
  const [sizeList, setSizeList] = useState([])
  const [timeLeft, setTimeLeft] = useState(null)
  const description = data?.description

  const [mintQty, setMintQty] = useState(1)
  const [buyNowLoading, setBuyNowLoading] = useState(false)
  const [isExpired, setIsExpired] = useState(false)
  const [showEditMerch, setShowEditMerch] = useState(false)
  const [showNftMenuEditModal, setShowNftMenuEditModal] = useState(false)
  const [showAlert, setShowAlert] = useState(false)
  const [alertData, setAlertData] = useState<any[]>([])
  const [color, setColor] = useState(
    productDetail.product_type_id === 0 && productDetail.options.colors.length > 0
      ? productDetail.options.colors[0]
      : 'white'
  )

  useEffect(() => {
    if (productDetail.sale_end_at !== null && getTimeDifference(productDetail.sale_end_at) < 0) setIsExpired(true)
    let size_list
    switch (productDetail.product_type_id) {
      case 0:
        size_list = productDetail.options.sizes.map(item => ({ Size: item }))
        break
      case 1:
      case 2:
        size_list = SizeList[2].size
        break
      case 3:
      case 4:
        size_list = SizeList[3].size
        break
      case 5:
      case 6:
      case 60:
        size_list = SizeList[0].size
        break
      case 7:
      case 8:
        size_list = SizeList[1].size
        break
      case 9:
      case 10:
        size_list = SizeList[4].size
        break
      case 12:
      case 13:
        let sizes = []
        if (productDetail.options.sizes) {
          productDetail.options.sizes.map((item, index) => sizes.push({ id: index, Size: item }))
        }
        size_list = sizes
        break
      case 22:
      case 23:
        size_list = SizeList[11].size // S - 4XL
        break
      case 25:
      case 26:
        size_list = SizeList[12].size // S - 5XL
        break
      case 27:
        size_list = SizeList[19].size // S - 4XL
        break
      case 28:
        size_list = SizeList[13].size // S - 4XL
        break
      case 29:
        size_list = SizeList[15].size // S - 4XL
        break
      case 30:
        size_list = SizeList[14].size // XS - 3XL
        break
      case 31:
      case 32:
        size_list = SizeList[20].size // S - 3XL
        break
      case 33:
        size_list = SizeList[21].size // S - 3XL
        break
      case 34:
      case 35:
        size_list = SizeList[10].size // XS - 2XL
        break
      case 36:
      case 37:
        size_list = SizeList[16].size // S - 2XL
        break
      case 38:
      case 39:
        size_list = SizeList[17].size // S - L
        break
      case 40:
      case 41:
      case 42:
      case 43:
        size_list = []
        break
      case 47:
      case 48:
        size_list = SizeList[18].size
        break
      case 49:
      case 50:
        size_list = SizeList[22].size
        break
      case 52:
      case 53:
        size_list = SizeList[25].size
        break
      case 54:
      case 55:
        size_list = SizeList[23].size
        break
      case 56:
      case 57:
        size_list = SizeList[24].size
        break
      default:
        size_list = []
        break
    }
    let sizes = []

    size_list.map((size, index) => {
      if (index === Math.round(size_list.length / 2)) {
        sizes.push({ id: index, name: size.Size, selected: true })
        setMerchSize(size.Size)
      } else {
        sizes.push({ id: index, name: size.Size, selected: false })
      }
    })

    setSizeList(sizes)

    if (productDetail.sale_start_at !== null) {
      if (getStartTime() === null) return

      setTimeLeft(calculateAuctionTimeLeft(getStartTime()))

      const timer = setInterval(() => {
        let timeLeft = calculateAuctionTimeLeft(getStartTime())
        setTimeLeft(timeLeft)
      }, 1000)

      return () => clearTimeout(timer)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productDetail])

  const getStartTime = () => {
    let difference = getTimeDifference(productDetail.sale_start_at)

    if (difference >= 0) {
      return productDetail.sale_start_at
    } else {
      return productDetail.sale_end_at
    }
  }

  const onClickSize = index => {
    let newSize = []
    sizeList.map(item => {
      if (item.id === index) {
        newSize.push({ ...item, selected: true })
        setMerchSize(item.name)
      } else {
        newSize.push({ ...item, selected: false })
      }
    })
    setSizeList(newSize)
  }

  const getApparelName = () => {
    let type = 'Unisex'
    let name = getApparelType(productDetail.product_type_id)

    let list = ShopApparelList.filter(item => item.base === name && item.sub_type == type)
    if (list.length > 0) return list[0].name
    else return name
  }

  const getApparelLabel = () => {
    let type = 'Unisex'
    let name = getApparelType(productDetail.product_type_id)

    let list = ShopApparelList.filter(item => item.base === name && item.sub_type == type)
    if (list.length > 0) return list[0].label
    else return name
  }

  const getStartStatus = () => {
    if (getTimeDifference(productDetail.sale_start_at) > 0) return 'Starts in'

    if (productDetail.sale_end_at === null) return ''

    return 'Ends in'
  }

  const downloadFiles = async () => {
    let urls = []
    if (productDetail.fulfillment_type === 'foster') {
      productDetail.options.addons.map((item, index) => {
        urls.push(item.mockup_url)
      })
    } else {
      productDetail.options.product_images.map((item, index) => {
        urls.push(item)
      })
    }
    for (let index = 0; index < urls.length; index++) {
      const data = {
        url: urls[index],
      }
      let response = await fetch('/api/download', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
      const blob = await response.blob()
      const downloadUrl = window.URL.createObjectURL(blob)

      // Create an anchor tag to perform the download
      const link = document.createElement('a')
      link.href = downloadUrl
      link.setAttribute('download', `MerchFile-${index}.png`) // Set the default filename
      document.body.appendChild(link)
      link.click()
      link.parentNode.removeChild(link)
      window.URL.revokeObjectURL(downloadUrl)
    }
  }

  const onClickAddCart = () => {
    if (!connected) {
      setVisible(true)
      return
    }

    let existingData = JSON.parse(localStorage.getItem('cart_v2')) || []
    if (!Array.isArray(existingData)) {
      existingData = []
    }

    let cart_data = {
      version: 'v2',
      type,
      merchEdition: false,
      cost: ((productDetail.selling_price / 100) * mintQty).toFixed(2),
      productId,
      data,
      fosterUrl: window.location.href,
      merchList,
      rawList,
    }
    existingData.push(cart_data)
    localStorage.setItem('cart_v2', JSON.stringify(existingData))

    setAlertData([
      {
        id: 0,
        title: 'Item Added to Your Cart!',
        description: `${data?.name} is ready and waiting in your cart. Feel free to browse for more goodies or head to checkout whenever you're ready.`,
        type: 'success',
      },
    ])
    setShowAlert(true)

    dispatch({ type: 'set', cartUpdated: true })
  }

  return (
    <div className={styles.container}>
      <div className={styles.rightSection}>
        <div>
          <div className="w-full">
            <div className="w-full">
              <div className="w-full justify-between flex items-center gap-[15px] lg:gap-[20px]">
                <div className="flex gap-[8px] items-center">
                  <div className="flex gap-[6px] items-center">
                    <SolanaLogoIcon />
                    <div className={styles.price}>
                      {((productDetail.selling_price / 100 / solToUsdRate) * mintQty).toFixed(2)}
                    </div>
                  </div>
                  <div className={styles.priceUS}> ${((productDetail.selling_price / 100) * mintQty).toFixed(2)}</div>
                </div>
                <div className="hidden items-center sm:flex">
                  <MenuEditMerch
                    // explorerURL={`/${username}/merch/${productDetail.id}`}
                    setShowEditMerch={setShowEditMerch}
                    isCreatedMerch={publicKey?.toBase58() === userDetail?.wallet_id}
                    setOpenShareModal={setOpenShareModal}
                    showDownloadMockups={
                      publicKey?.toBase58() === userDetail?.wallet_id && productDetail.fulfillment_type === 'foster'
                    }
                    downloadFiles={downloadFiles}
                  />
                </div>
                <div
                  className="w-[32px] h-[32px] flex items-center justify-center sm:hidden"
                  onClick={() => setShowNftMenuEditModal(true)}
                >
                  <ThreeDotIcon alt="" />
                </div>
              </div>
              <div className={styles.productName}>{data?.name}</div>
              {description?.length > 0 && (
                <div className="w-full mt-[15px] lg:mt-[25px]">
                  <NFTDescriptionSection description={description} />
                </div>
              )}
            </div>

            <div className="mt-[15px] flex flex-wrap gap-[15px] lg:gap-[30px]">
              <div className="flex flex-wrap sm:gap-[30px] gap-[10px]">
                <div>
                  <Link href={`/${userDetail.username}`} passHref>
                    <a>
                      <div
                        className="flex items-center gap-[10px]"
                        onClick={() => router.push(`/${userDetail.username}`)}
                      >
                        <div className="w-[30px] h-[30px] rounded-full overflow-hidden">
                          <ImageWithFoster
                            src={userDetail.profile_picture?.length > 0 ? userDetail.profile_picture : DefaultAvatar}
                            alt=""
                          />
                        </div>
                        <div className={styles.username}>{getDisplayUserName(userDetail.username)}</div>
                      </div>
                    </a>
                  </Link>
                </div>
                {/* {type !== 'foster' && (
                  <div>
                    <div className={styles.creator}>{productDetail.supply ? 'Limited Supply' : 'Open Supply'}</div>
                    <div>
                      <div className={styles.supplyRound}>
                        {productDetail.supply
                          ? `${productDetail.supply - productDetail.current_supply}/${productDetail.supply} left`
                          : `${productDetail.current_supply} sold`}
                      </div>
                    </div>
                  </div>
                )} */}
              </div>
            </div>

            {productDetail.deleted_at === null &&
              productDetail.product_type_id === 0 &&
              productDetail.options.colors.length > 1 && (
                <div className="mt-[40px] lg:mt-[40px]">
                  <div className="w-full flex justify-between items-center">
                    <div className={styles.selectSize}>Select Color</div>
                  </div>
                  <div className="mt-[15px]">
                    <div className="w-full flex flex-wrap gap-[10px]">
                      {productDetail.options.colors.map((item, index) => (
                        <div
                          key={index}
                          className={`${
                            item === 'white'
                              ? styles.whiteColor
                              : item === 'black'
                              ? styles.blackColor
                              : item === 'gray'
                              ? styles.darkGrayColor
                              : item === 'navy'
                              ? styles.blueColor
                              : item === 'red'
                              ? styles.redWhiteColor
                              : item === 'dusty_blue'
                              ? styles.greenColor
                              : item === 'faded_black'
                              ? styles.grayDarkColor
                              : item === 'graphite'
                              ? styles.grayMiddleColor
                              : item === 'mauve'
                              ? styles.mauveColor
                              : item === 'peach'
                              ? styles.pinkColor
                              : item === 'creme'
                              ? styles.yellowColor
                              : item === 'bone'
                              ? styles.yellowColor
                              : styles.blackColor
                          } ${color === item ? styles.selectedColor : styles.unselectedColor}`}
                          onClick={() => {
                            if (color === item) return
                            setColor(item)
                            setMerchColor(item)
                          }}
                        ></div>
                      ))}
                    </div>
                  </div>
                  {type === 'foster' && productDetail.product_type_id !== 0 && (
                    <div className={styles.sizeChart} onClick={() => setTableModal(true)}>
                      Size Chart »
                    </div>
                  )}
                </div>
              )}

            {productDetail.deleted_at === null && sizeList.length > 0 && (
              <div className="mt-[40px] lg:mt-[40px]">
                <div className="w-full flex justify-between items-center">
                  <div className={styles.selectSize}>Select Size</div>
                </div>
                <div className="mt-[15px]">
                  <div className="w-full flex flex-wrap gap-[10px]">
                    {sizeList.map((item, index) => (
                      <div
                        key={index}
                        className={item.selected ? styles.selectedSize : styles.unselectedSize}
                        onClick={() => onClickSize(index)}
                      >
                        {item.name}
                      </div>
                    ))}
                  </div>
                </div>
                {type === 'foster' && productDetail.product_type_id !== 0 && (
                  <div className={styles.sizeChart} onClick={() => setTableModal(true)}>
                    Size Chart »
                  </div>
                )}
              </div>
            )}
          </div>

          <div className="w-full lg:mt-[56px] mt-[60px]">
            {type === 'foster' ? (
              <div>
                {productDetail.deleted_at === null &&
                  (productDetail.supply === null || productDetail.supply - productDetail.current_supply > 1) &&
                  (timeLeft === null || !isExpired) && (
                    <div className={styles.mintQty}>
                      <div
                        onClick={() => {
                          if (mintQty > 1) {
                            setMintQty(mintQty - 1)
                            setQuantity(mintQty - 1)
                          }
                        }}
                      >
                        <div className={styles.minus}>-</div>
                      </div>
                      <div className={styles.mintLabel}>
                        Qty&nbsp;<div className={styles.mintValue}>{mintQty}</div>
                      </div>
                      <div
                        onClick={() => {
                          if (productDetail.supply) {
                            if (mintQty < productDetail.supply - productDetail.current_supply) {
                              setMintQty(mintQty + 1)
                              setQuantity(mintQty + 1)
                            }
                          } else {
                            setMintQty(mintQty + 1)
                            setQuantity(mintQty + 1)
                          }
                        }}
                      >
                        <div className={styles.minus}>+</div>
                      </div>
                    </div>
                  )}
                <div className="w-full mt-[30px]">
                  <div className="w-full flex items-center justify-between mb-[7px]">
                    <div className={styles.supplyValue}>
                      {productDetail.supply &&
                        `${productDetail.supply - productDetail.current_supply}/${productDetail.supply} left`}
                    </div>

                    <div>
                      {(productDetail.supply === null || productDetail.supply - productDetail.current_supply > 0) &&
                        timeLeft && (
                          <div>
                            {isExpired ? (
                              <div></div>
                            ) : (
                              <div className={styles.creator}>
                                <div>{productDetail.supply ? 'Limited Time Only •' : 'Live •'}</div>
                                <div>{getStartStatus()}</div>
                                <div className="flex">
                                  {timeLeft && timeLeft['days'] !== '00' && (
                                    <div className="flex mr-[3px]">
                                      {timeLeft && timeLeft['days']}
                                      {timeLeft && <div>d</div>}
                                    </div>
                                  )}
                                  <div className="flex">
                                    {timeLeft && timeLeft['hours']}
                                    {timeLeft && <div>h</div>}
                                  </div>
                                  {/* <div className={styles.endTimeContainer}>
                                    <div className={styles.endTimeCart}>
                                      {timeLeft && timeLeft['minutes']}
                                      {timeLeft && <div className={styles.bidDescCart}>m</div>}
                                    </div>
                                  </div>
                                  <div className={styles.endTimeContainer}>
                                    <div className={styles.endTimeCart}>
                                      {timeLeft && timeLeft['seconds']}
                                      {timeLeft && <div className={styles.bidDescCart}>s</div>}
                                    </div>
                                  </div> */}
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                    </div>
                  </div>
                  {productDetail.supply && (
                    <div className={styles.progressBG}>
                      <div
                        className={styles.progressBar}
                        style={{ width: `${(productDetail.current_supply / productDetail.supply) * 100}%` }}
                      />
                    </div>
                  )}
                </div>

                {productDetail.deleted_at === null &&
                  (productDetail.supply === null || productDetail.supply - productDetail.current_supply > 0) &&
                  (timeLeft === null || !isExpired) && (
                    <div className="w-full">
                      {buyNowLoading ? (
                        <LoadingButton fullWidth />
                      ) : (
                        <GradientButton
                          fullWidth
                          height={45}
                          borderRadius={23}
                          label="Buy Now"
                          disabled={getStartStatus() === 'Starts in' || isExpired}
                          onClick={() => onClickBuyNow()}
                        />
                      )}
                    </div>
                  )}

                <div className="w-full flex flex-col lg:flex-row gap-[15px] lg:gap-[15px]">
                  {productDetail.deleted_at === null &&
                    (productDetail.supply === null || productDetail.supply - productDetail.current_supply > 0) &&
                    (timeLeft === null || !isExpired) && (
                      <div className="w-full mt-[11px]">
                        <OutlineButton
                          fullWidth
                          height={45}
                          borderRadius={23}
                          label="Add to Cart"
                          fontSize={16}
                          onClick={() => onClickAddCart()}
                        />
                      </div>
                    )}
                </div>
              </div>
            ) : (
              <div>
                <div className="w-full">
                  {(productDetail.supply === null || productDetail.supply - productDetail.current_supply > 1) &&
                    (timeLeft === null || !isExpired) && (
                      <div className={styles.mintQty}>
                        <div
                          onClick={() => {
                            if (mintQty > 1) {
                              setMintQty(mintQty - 1)
                              setQuantity(mintQty - 1)
                            }
                          }}
                        >
                          <div className={styles.minus}>-</div>
                        </div>
                        <div className={styles.mintLabel}>
                          Qty&nbsp;<div className={styles.mintValue}>{mintQty}</div>
                        </div>
                        <div
                          onClick={() => {
                            if (productDetail.supply) {
                              if (mintQty < productDetail.supply - productDetail.current_supply) {
                                setMintQty(mintQty + 1)
                                setQuantity(mintQty + 1)
                              }
                            } else {
                              setMintQty(mintQty + 1)
                              setQuantity(mintQty + 1)
                            }
                          }}
                        >
                          <div className={styles.minus}>+</div>
                        </div>
                      </div>
                    )}

                  <div className="w-full mt-[30px]">
                    <div className="w-full flex items-center justify-between mb-[7px]">
                      <div className={styles.supplyValue}>
                        {productDetail.supply &&
                          `${productDetail.supply - productDetail.current_supply}/${productDetail.supply} left`}
                      </div>

                      <div>
                        {(productDetail.supply === null || productDetail.supply - productDetail.current_supply > 0) &&
                          timeLeft && (
                            <div>
                              {isExpired ? (
                                <div></div>
                              ) : (
                                <div className={styles.creator}>
                                  <div>{productDetail.supply ? 'Limited Time Only •' : 'Live •'}</div>
                                  <div>{getStartStatus()}</div>
                                  <div className="flex">
                                    {timeLeft && timeLeft['days'] !== '00' && (
                                      <div className="flex mr-[3px]">
                                        {timeLeft && timeLeft['days']}
                                        {timeLeft && <div>d</div>}
                                      </div>
                                    )}
                                    <div className="flex">
                                      {timeLeft && timeLeft['hours']}
                                      {timeLeft && <div>h</div>}
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          )}
                      </div>
                    </div>

                    {productDetail.supply && (
                      <div className={styles.progressBG}>
                        <div
                          className={styles.progressBar}
                          style={{ width: `${(productDetail.current_supply / productDetail.supply) * 100}%` }}
                        />
                      </div>
                    )}
                  </div>

                  {(productDetail.supply === null || productDetail.supply - productDetail.current_supply > 0) &&
                    (timeLeft === null || !isExpired) && (
                      <div className="w-full">
                        {buyNowLoading ? (
                          <LoadingButton fullWidth />
                        ) : (
                          <GradientButton
                            fullWidth
                            height={45}
                            borderRadius={23}
                            label="Buy Now"
                            disabled={getStartStatus() === 'Starts in' || isExpired}
                            onClick={() => onClickBuyNow()}
                          />
                        )}
                      </div>
                    )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {showNftMenuEditModal && (
        <MerchMenuEditModal
          open={showNftMenuEditModal}
          onClose={() => setShowNftMenuEditModal(false)}
          setShowEditMerch={setShowEditMerch}
          isCreatedMerch={publicKey?.toBase58() === userDetail?.wallet_id}
          setOpenShareModal={setOpenShareModal}
          showDownloadMockups={
            publicKey?.toBase58() === userDetail?.wallet_id && productDetail.fulfillment_type === 'foster'
          }
          downloadFiles={downloadFiles}
        />
      )}
      <div className="mt-[91px]">
        <MerchOrderDetail type={type} productDetail={productDetail} />
      </div>

      {showEditMerch && (
        <MerchDetailEditModal
          merchImage={merchList[0]}
          userId={userDetail.id}
          productId={productId}
          data={data}
          open={showEditMerch}
          onClose={() => setShowEditMerch(false)}
          onSuccess={product => {
            setData(product)
            setAlertData([
              {
                id: 0,
                title: 'Your product has been updated',
                description: `Product details have been sucessfully updated.`,
                type: 'success',
              },
            ])
            setShowAlert(true)
          }}
        />
      )}

      {openShareModal && (
        <SocialShareModal
          open={openShareModal}
          close={() => setOpenShareModal(false)}
          vote={share}
          setVote={setShare}
          voteCount={shareCount}
          setVoteCount={setShareCount}
          message={'Check out this fresh merch on @foster_protocol #fostermarketplace'}
          url={`/${username}/merch/${productDetail.id}`}
        />
      )}

      <SizeChartModal
        open={tableModal}
        title={getApparelName()}
        label={getApparelLabel()}
        onClose={() => setTableModal(false)}
      />

      <Alert
        open={showAlert}
        close={() => {
          setShowAlert(false)
          if (showEditMerch) {
            setShowEditMerch(false)
          }
        }}
        data={alertData}
      />
    </div>
  )
}

export default MerchOrderMain
